import { createRoot } from 'solid-js'
import { deepClone } from '../../deep_clone'
import type { GameObject3DFrameEventFunction } from '../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate'
import { createEraseTileOption } from '../map_editor/erase_map_tile'
import { defaultPaintTileOption } from '../map_editor/paint_tile_option_list'
import { initViewCtx } from '../view_ctx'
import blankStateForEngineInit from './blankStateForEngineInit'
import { Engine } from './Engine.type'

let lastEngineId: number = 0

export default function createEngineRoot(): Engine {
  return createRoot((dispose) => {
    const gcELL : Array<() => void> = [dispose]
    const ofELL : Array<GameObject3DFrameEventFunction> = []
    const defaultState = blankStateForEngineInit()
    const engine: Engine = {
      id: ++lastEngineId,
      eraseToolOption: createEraseTileOption(),
      paintToolOption: defaultPaintTileOption(),
      selectedPlayerId: null,
      selectedPositionEnts: [],
      draftMove: null,
      state: defaultState,
      prevState: deepClone(defaultState),
      viewCtx: initViewCtx(),
      actionLogs: [],
      ofELL() { return ofELL },
      gcELL() { return gcELL },
    }

    return engine
  })
}
